export const ModalData = [

  {
    modalType: "root",
    name: "root",
    content: [
      "click",
      "keydown"
        ]
  },
  {
    modalType: "route",
    name: "route",
    content: [
      "click",
      "keydown"
    ]
  },
  {
    modalType: "window",
    name: "window",
    content: [
      {
        "event": "abort",
        "action": "CHANNEL_WINDOW_ABORT_EVENT"
      },
      {
        "event": "afterprint",
        "action": "CHANNEL_WINDOW_AFTERPRINT_EVENT"
      },
      {
        "event": "animationend",
        "action": "CHANNEL_WINDOW_ANIMATIONEND_EVENT"
      },
      {
        "event": "animationiteration",
        "action": "CHANNEL_WINDOW_ANIMATIONITERATION_EVENT"
      },
      {
        "event": "animationstart",
        "action": "CHANNEL_WINDOW_ANIMATIONSTART_EVENT"
      },
      {
        "event": "appinstalled",
        "action": "CHANNEL_WINDOW_APPINSTALLED_EVENT"
      },
      {
        "event": "beforeprint",
        "action": "CHANNEL_WINDOW_BEFOREPRINT_EVENT"
      },
      {
        "event": "beforeunload",
        "action": "CHANNEL_WINDOW_BEFOREUNLOAD_EVENT"
      },
      {
        "event": "beginevent",
        "action": "CHANNEL_WINDOW_BEGINEVENT_EVENT"
      },
      {
        "event": "blur",
        "action": "CHANNEL_WINDOW_BLUR_EVENT"
      },
      {
        "event": "cached",
        "action": "CHANNEL_WINDOW_CACHED_EVENT"
      },
      {
        "event": "change",
        "action": "CHANNEL_WINDOW_CHANGE_EVENT"
      },
      {
        "event": "click",
        "action": "CHANNEL_WINDOW_CLICK_EVENT"
      },
      {
        "event": "close",
        "action": "CHANNEL_WINDOW_CLOSE_EVENT"
      },
      {
        "event": "compositionend",
        "action": "CHANNEL_WINDOW_COMPOSITIONEND_EVENT"
      },
      {
        "event": "compositionstart",
        "action": "CHANNEL_WINDOW_COMPOSITIONSTART_EVENT"
      },
      {
        "event": "compositionupdate",
        "action": "CHANNEL_WINDOW_COMPOSITIONUPDATE_EVENT"
      },
      {
        "event": "copy",
        "action": "CHANNEL_WINDOW_COPY_EVENT"
      },
      {
        "event": "cut",
        "action": "CHANNEL_WINDOW_CUT_EVENT"
      },
      {
        "event": "dblclick",
        "action": "CHANNEL_WINDOW_DBLCLICK_EVENT"
      },
      {
        "event": "devicechange",
        "action": "CHANNEL_WINDOW_DEVICECHANGE_EVENT"
      },
      {
        "event": "devicelight",
        "action": "CHANNEL_WINDOW_DEVICELIGHT_EVENT"
      },
      {
        "event": "devicemotion",
        "action": "CHANNEL_WINDOW_DEVICEMOTION_EVENT"
      },
      {
        "event": "deviceorientation",
        "action": "CHANNEL_WINDOW_DEVICEORIENTATION_EVENT"
      },
      {
        "event": "deviceproximity",
        "action": "CHANNEL_WINDOW_DEVICEPROXIMITY_EVENT"
      },
      {
        "event": "domattributenamechanged",
        "action": "CHANNEL_WINDOW_DOMATTRIBUTENAMECHANGED_EVENT"
      },
      {
        "event": "domattrmodified",
        "action": "CHANNEL_WINDOW_DOMATTRMODIFIED_EVENT"
      },
      {
        "event": "domcharacterdatamodified",
        "action": "CHANNEL_WINDOW_DOMCHARACTERDATAMODIFIED_EVENT"
      },
      {
        "event": "domcontentloaded",
        "action": "CHANNEL_WINDOW_DOMCONTENTLOADED_EVENT"
      },
      {
        "event": "domelementnamechanged",
        "action": "CHANNEL_WINDOW_DOMELEMENTNAMECHANGED_EVENT"
      },
      {
        "event": "dragend",
        "action": "CHANNEL_WINDOW_DRAGEND_EVENT"
      },
      {
        "event": "dragenter",
        "action": "CHANNEL_WINDOW_DRAGENTER_EVENT"
      },
      {
        "event": "dragleave",
        "action": "CHANNEL_WINDOW_DRAGLEAVE_EVENT"
      },
      {
        "event": "dragover",
        "action": "CHANNEL_WINDOW_DRAGOVER_EVENT"
      },
      {
        "event": "dragstart",
        "action": "CHANNEL_WINDOW_DRAGSTART_EVENT"
      },
      {
        "event": "drag",
        "action": "CHANNEL_WINDOW_DRAG_EVENT"
      },
      {
        "event": "drop",
        "action": "CHANNEL_WINDOW_DROP_EVENT"
      },
      {
        "event": "error",
        "action": "CHANNEL_WINDOW_ERROR_EVENT"
      },
      {
        "event": "focusin",
        "action": "CHANNEL_WINDOW_FOCUSIN_EVENT"
      },
      {
        "event": "focus",
        "action": "CHANNEL_WINDOW_FOCUS_EVENT"
      },
      {
        "event": "fullscreenchange",
        "action": "CHANNEL_WINDOW_FULLSCREENCHANGE_EVENT"
      },
      {
        "event": "fullscreenerror",
        "action": "CHANNEL_WINDOW_FULLSCREENERROR_EVENT"
      },
      {
        "event": "hashchange",
        "action": "CHANNEL_WINDOW_HASHCHANGE_EVENT"
      },
      {
        "event": "input",
        "action": "CHANNEL_WINDOW_INPUT_EVENT"
      },
      {
        "event": "invalid",
        "action": "CHANNEL_WINDOW_INVALID_EVENT"
      },
      {
        "event": "keydown",
        "action": "CHANNEL_WINDOW_KEYDOWN_EVENT"
      },
      {
        "event": "keypress",
        "action": "CHANNEL_WINDOW_KEYPRESS_EVENT"
      },
      {
        "event": "keyup",
        "action": "CHANNEL_WINDOW_KEYUP_EVENT"
      },
      {
        "event": "load",
        "action": "CHANNEL_WINDOW_LOAD_EVENT"
      },
      {
        "event": "message",
        "action": "CHANNEL_WINDOW_MESSAGE_EVENT"
      },
      {
        "event": "mousedown",
        "action": "CHANNEL_WINDOW_MOUSEDOWN_EVENT"
      },
      {
        "event": "mouseenter",
        "action": "CHANNEL_WINDOW_MOUSEENTER_EVENT"
      },
      {
        "event": "mouseleave",
        "action": "CHANNEL_WINDOW_MOUSELEAVE_EVENT"
      },
      {
        "event": "mousemove",
        "action": "CHANNEL_WINDOW_MOUSEMOVE_EVENT"
      },
      {
        "event": "mouseout",
        "action": "CHANNEL_WINDOW_MOUSEOUT_EVENT"
      },
      {
        "event": "mouseover",
        "action": "CHANNEL_WINDOW_MOUSEOVER_EVENT"
      },
      {
        "event": "mouseup",
        "action": "CHANNEL_WINDOW_MOUSEUP_EVENT"
      },
      {
        "event": "mousewheel",
        "action": "CHANNEL_WINDOW_MOUSEWHEEL_EVENT"
      },
      {
        "event": "offline",
        "action": "CHANNEL_WINDOW_OFFLINE_EVENT"
      },
      {
        "event": "online",
        "action": "CHANNEL_WINDOW_ONLINE_EVENT"
      },
      {
        "event": "open",
        "action": "CHANNEL_WINDOW_OPEN_EVENT"
      },
      {
        "event": "pagehide",
        "action": "CHANNEL_WINDOW_PAGEHIDE_EVENT"
      },
      {
        "event": "pageshow",
        "action": "CHANNEL_WINDOW_PAGESHOW_EVENT"
      },
      {
        "event": "paste",
        "action": "CHANNEL_WINDOW_PASTE_EVENT"
      },
      {
        "event": "popstate",
        "action": "CHANNEL_WINDOW_POPSTATE_EVENT"
      },
      {
        "event": "progressevents",
        "action": "CHANNEL_WINDOW_PROGRESSEVENTS_EVENT"
      },
      {
        "event": "reset",
        "action": "CHANNEL_WINDOW_RESET_EVENT"
      },
      {
        "event": "storage",
        "action": "CHANNEL_WINDOW_STORAGE_EVENT"
      },
      {
        "event": "submit",
        "action": "CHANNEL_WINDOW_SUBMIT_EVENT"
      },
      {
        "event": "transitioncancel",
        "action": "CHANNEL_WINDOW_TRANSITIONCANCEL_EVENT"
      },
      {
        "event": "transitionend",
        "action": "CHANNEL_WINDOW_TRANSITIONEND_EVENT"
      },
      {
        "event": "transitionrun",
        "action": "CHANNEL_WINDOW_TRANSITIONRUN_EVENT"
      },
      {
        "event": "transitionstart",
        "action": "CHANNEL_WINDOW_TRANSITIONSTART_EVENT"
      },
      {
        "event": "unload",
        "action": "CHANNEL_WINDOW_UNLOAD_EVENT"
      }
    ]
  },
  {
    modalType: "broadcastEvents",
    name: "broadcastEvents",

    content: [
      {
        "title": "Common UI Events",
        "arr": [
          {
            "event": "click",
            "action": "CHANNEL_UI_CLICK_EVENT"
          },
          {
            "event": "keydown",
            "action": "CHANNEL_UI_KEYDOWN_EVENT"
          },
          {
            "event": "keyup",
            "action": "CHANNEL_UI_KEYUP_EVENT"
          },
          {
            "event": "touchstart",
            "action": "CHANNEL_UI_TOUCHSTART_EVENT"
          },
          {
            "event": "touchmove",
            "action": "CHANNEL_UI_TOUCHMOVE_EVENT"
          },
          {
            "event": "touchend",
            "action": "CHANNEL_UI_TOUCHEND_EVENT"
          },
          {
            "event": "touchcancel",
            "action": "CHANNEL_UI_TOUCHCANCEL_EVENT"
          },
          {
            "event": "input",
            "action": "CHANNEL_UI_INPUT_EVENT"
          },
          {
            "event": "change",
            "action": "CHANNEL_UI_CHANGE_EVENT"
          },
          {
            "event": "submit",
            "action": "CHANNEL_UI_SUBMIT_EVENT"
          },
          {
            "event": "focus",
            "action": "CHANNEL_UI_FOCUS_EVENT"
          },
          {
            "event": "blur",
            "action": "CHANNEL_UI_BLUR_EVENT"
          },
          {
            "event": "mousedown",
            "action": "CHANNEL_UI_MOUSEDOWN_EVENT"
          },
          {
            "event": "mouseup",
            "action": "CHANNEL_UI_MOUSEUP_EVENT"
          },
          {
            "event": "mousemove",
            "action": "CHANNEL_UI_MOUSEMOVE_EVENT"
          },
          {
            "event": "mouseenter",
            "action": "CHANNEL_UI_MOUSEENTER_EVENT"
          },
          {
            "event": "mouseleave",
            "action": "CHANNEL_UI_MOUSELEAVE_EVENT"
          },
          {
            "event": "mouseout",
            "action": "CHANNEL_UI_MOUSEOUT_EVENT"
          },
          {
            "event": "mouseover",
            "action": "CHANNEL_UI_MOUSEOVER_EVENT"
          },
          {
            "event": "animationstart",
            "action": "CHANNEL_UI_ANIMATIONSTART_EVENT"
          },
          {
            "event": "animationend",
            "action": "CHANNEL_UI_ANIMATIONEND_EVENT"
          },
          {
            "event": "animationiteration",
            "action": "CHANNEL_UI_ANIMATIONITERATION_EVENT"
          },
          {
            "event": "pause",
            "action": "CHANNEL_UI_PAUSE_EVENT"
          },
          {
            "event": "play",
            "action": "CHANNEL_UI_PLAY_EVENT"
          },
          {
            "event": "playing",
            "action": "CHANNEL_UI_PLAYING_EVENT"
          },
          {
            "event": "transitionstart",
            "action": "CHANNEL_UI_TRANSITIONSTART_EVENT"
          },
          {
            "event": "transitionend",
            "action": "CHANNEL_UI_TRANSITIONEND_EVENT"
          }
        ]
      },
      {
        "title": "Other UI Events",
        "arr": [
          {
            "event": "abort",
            "action": "CHANNEL_UI_ABORT_EVENT"
          },
          {
            "event": "animationcancel",
            "action": "CHANNEL_UI_ANIMATIONCANCEL_EVENT"
          },
          {
            "event": "beforeinput",
            "action": "CHANNEL_UI_BEFOREINPUT_EVENT"
          },
          {
            "event": "beforeunload",
            "action": "CHANNEL_UI_BEFOREUNLOAD_EVENT"
          },
          {
            "event": "canplay",
            "action": "CHANNEL_UI_CANPLAY_EVENT"
          },
          {
            "event": "canplaythrough",
            "action": "CHANNEL_UI_CANPLAYTHROUGH_EVENT"
          },
          {
            "event": "compositionend",
            "action": "CHANNEL_UI_COMPOSITIONEND_EVENT"
          },
          {
            "event": "compositionstart",
            "action": "CHANNEL_UI_COMPOSITIONSTART_EVENT"
          },
          {
            "event": "contextmenu",
            "action": "CHANNEL_UI_CONTEXTMENU_EVENT"
          },
          {
            "event": "copy",
            "action": "CHANNEL_UI_COPY_EVENT"
          },
          {
            "event": "cuechange",
            "action": "CHANNEL_UI_CUECHANGE_EVENT"
          },
          {
            "event": "cut",
            "action": "CHANNEL_UI_CUT_EVENT"
          },
          {
            "event": "dblclick",
            "action": "CHANNEL_UI_DBLCLICK_EVENT"
          },
          {
            "event": "domcontentloaded",
            "action": "CHANNEL_UI_DOMCONTENTLOADED_EVENT"
          },
          {
            "event": "dragend",
            "action": "CHANNEL_UI_DRAGEND_EVENT"
          },
          {
            "event": "dragover",
            "action": "CHANNEL_UI_DRAGOVER_EVENT"
          },
          {
            "event": "dragstart",
            "action": "CHANNEL_UI_DRAGSTART_EVENT"
          },
          {
            "event": "drop",
            "action": "CHANNEL_UI_DROP_EVENT"
          },
          {
            "event": "durationchange",
            "action": "CHANNEL_UI_DURATIONCHANGE_EVENT"
          },
          {
            "event": "emptied",
            "action": "CHANNEL_UI_EMPTIED_EVENT"
          },
          {
            "event": "ended",
            "action": "CHANNEL_UI_ENDED_EVENT"
          },
          {
            "event": "enterpictureinpicture",
            "action": "CHANNEL_UI_ENTERPICTUREINPICTURE_EVENT"
          },
          {
            "event": "error",
            "action": "CHANNEL_UI_ERROR_EVENT"
          },
          {
            "event": "formdata",
            "action": "CHANNEL_UI_FORMDATA_EVENT"
          },
          {
            "event": "fullscreenchange",
            "action": "CHANNEL_UI_FULLSCREENCHANGE_EVENT"
          },
          {
            "event": "fullscreenchange",
            "action": "CHANNEL_UI_FULLSCREENCHANGE_EVENT"
          },
          {
            "event": "fullscreenerror",
            "action": "CHANNEL_UI_FULLSCREENERROR_EVENT"
          },
          {
            "event": "fullscreenerror",
            "action": "CHANNEL_UI_FULLSCREENERROR_EVENT"
          },
          {
            "event": "gamepadconnected",
            "action": "CHANNEL_UI_GAMEPADCONNECTED_EVENT"
          },
          {
            "event": "gamepaddisconnected",
            "action": "CHANNEL_UI_GAMEPADDISCONNECTED_EVENT"
          },
          {
            "event": "gotpointercapture",
            "action": "CHANNEL_UI_GOTPOINTERCAPTURE_EVENT"
          },
          {
            "event": "hashchange",
            "action": "CHANNEL_UI_HASHCHANGE_EVENT"
          },
          {
            "event": "leavepictureinpicture",
            "action": "CHANNEL_UI_LEAVEPICTUREINPICTURE_EVENT"
          },
          {
            "event": "load",
            "action": "CHANNEL_UI_LOAD_EVENT"
          },
          {
            "event": "loadeddata",
            "action": "CHANNEL_UI_LOADEDDATA_EVENT"
          },
          {
            "event": "loadedmetadata",
            "action": "CHANNEL_UI_LOADEDMETADATA_EVENT"
          },
          {
            "event": "loadend",
            "action": "CHANNEL_UI_LOADEND_EVENT"
          },
          {
            "event": "loadstart",
            "action": "CHANNEL_UI_LOADSTART_EVENT"
          },
          {
            "event": "lostpointercapture",
            "action": "CHANNEL_UI_LOSTPOINTERCAPTURE_EVENT"
          },
          {
            "event": "offline",
            "action": "CHANNEL_UI_OFFLINE_EVENT"
          },
          {
            "event": "online",
            "action": "CHANNEL_UI_ONLINE_EVENT"
          },
          {
            "event": "paste",
            "action": "CHANNEL_UI_PASTE_EVENT"
          },
          {
            "event": "pointercancel",
            "action": "CHANNEL_UI_POINTERCANCEL_EVENT"
          },
          {
            "event": "pointerdown",
            "action": "CHANNEL_UI_POINTERDOWN_EVENT"
          },
          {
            "event": "pointerenter",
            "action": "CHANNEL_UI_POINTERENTER_EVENT"
          },
          {
            "event": "pointerleave",
            "action": "CHANNEL_UI_POINTERLEAVE_EVENT"
          },
          {
            "event": "pointermove",
            "action": "CHANNEL_UI_POINTERMOVE_EVENT"
          },
          {
            "event": "pointerout",
            "action": "CHANNEL_UI_POINTEROUT_EVENT"
          },
          {
            "event": "pointerover",
            "action": "CHANNEL_UI_POINTEROVER_EVENT"
          },
          {
            "event": "pointerup",
            "action": "CHANNEL_UI_POINTERUP_EVENT"
          },
          {
            "event": "popstate",
            "action": "CHANNEL_UI_POPSTATE_EVENT"
          },
          {
            "event": "progress",
            "action": "CHANNEL_UI_PROGRESS_EVENT"
          },
          {
            "event": "ratechange",
            "action": "CHANNEL_UI_RATECHANGE_EVENT"
          },
          {
            "event": "removetrack",
            "action": "CHANNEL_UI_REMOVETRACK_EVENT"
          },
          {
            "event": "resize",
            "action": "CHANNEL_UI_RESIZE_EVENT"
          },
          {
            "event": "scroll",
            "action": "CHANNEL_UI_SCROLL_EVENT"
          },
          {
            "event": "seeked",
            "action": "CHANNEL_UI_SEEKED_EVENT"
          },
          {
            "event": "seeking",
            "action": "CHANNEL_UI_SEEKING_EVENT"
          },
          {
            "event": "select",
            "action": "CHANNEL_UI_SELECT_EVENT"
          },
          {
            "event": "selectend",
            "action": "CHANNEL_UI_SELECTEND_EVENT"
          },
          {
            "event": "selectionchange",
            "action": "CHANNEL_UI_SELECTIONCHANGE_EVENT"
          },
          {
            "event": "selectstart",
            "action": "CHANNEL_UI_SELECTSTART_EVENT"
          },
          {
            "event": "speechend",
            "action": "CHANNEL_UI_SPEECHEND_EVENT"
          },
          {
            "event": "speechstart",
            "action": "CHANNEL_UI_SPEECHSTART_EVENT"
          },
          {
            "event": "stalled",
            "action": "CHANNEL_UI_STALLED_EVENT"
          },
          {
            "event": "suspend",
            "action": "CHANNEL_UI_SUSPEND_EVENT"
          },
          {
            "event": "timeupdate",
            "action": "CHANNEL_UI_TIMEUPDATE_EVENT"
          },
          {
            "event": "track",
            "action": "CHANNEL_UI_TRACK_EVENT"
          },
          {
            "event": "transitioncancel",
            "action": "CHANNEL_UI_TRANSITIONCANCEL_EVENT"
          },
          {
            "event": "unload",
            "action": "CHANNEL_UI_UNLOAD_EVENT"
          },
          {
            "event": "visibilitychange",
            "action": "CHANNEL_UI_VISIBILITYCHANGE_EVENT"
          },
          {
            "event": "voicechanged",
            "action": "CHANNEL_UI_VOICECHANGED_EVENT"
          },
          {
            "event": "volumechange",
            "action": "CHANNEL_UI_VOLUMECHANGE_EVENT"
          },
          {
            "event": "vrdisplayactivate",
            "action": "CHANNEL_UI_VRDISPLAYACTIVATE_EVENT"
          },
          {
            "event": "vrdisplayblur",
            "action": "CHANNEL_UI_VRDISPLAYBLUR_EVENT"
          },
          {
            "event": "vrdisplayconnect",
            "action": "CHANNEL_UI_VRDISPLAYCONNECT_EVENT"
          },
          {
            "event": "vrdisplaydeactivate",
            "action": "CHANNEL_UI_VRDISPLAYDEACTIVATE_EVENT"
          },
          {
            "event": "vrdisplaydisconnect",
            "action": "CHANNEL_UI_VRDISPLAYDISCONNECT_EVENT"
          },
          {
            "event": "vrdisplayfocus",
            "action": "CHANNEL_UI_VRDISPLAYFOCUS_EVENT"
          },
          {
            "event": "vrdisplaypointerrestricted",
            "action": "CHANNEL_UI_VRDISPLAYPOINTERRESTRICTED_EVENT"
          },
          {
            "event": "vrdisplaypointerunrestricted",
            "action": "CHANNEL_UI_VRDISPLAYPOINTERUNRESTRICTED_EVENT"
          },
          {
            "event": "vrdisplaypresentchange",
            "action": "CHANNEL_UI_VRDISPLAYPRESENTCHANGE_EVENT"
          },
          {
            "event": "waiting",
            "action": "CHANNEL_UI_WAITING_EVENT"
          },
          {
            "event": "webglcontextlost",
            "action": "CHANNEL_UI_WEBGLCONTEXTLOST_EVENT"
          },
          {
            "event": "webglcontextrestored",
            "action": "CHANNEL_UI_WEBGLCONTEXTRESTORED_EVENT"
          },
          {
            "event": "webkitmouseforcechanged",
            "action": "CHANNEL_UI_WEBKITMOUSEFORCECHANGED_EVENT"
          },
          {
            "event": "webkitmouseforcedown",
            "action": "CHANNEL_UI_WEBKITMOUSEFORCEDOWN_EVENT"
          },
          {
            "event": "webkitmouseforceup",
            "action": "CHANNEL_UI_WEBKITMOUSEFORCEUP_EVENT"
          },
          {
            "event": "webkitmouseforcewillbegin",
            "action": "CHANNEL_UI_WEBKITMOUSEFORCEWILLBEGIN_EVENT"
          },
          {
            "event": "wheel",
            "action": "CHANNEL_UI_WHEEL_EVENT"
          }
        ]
      }
    ],
  },

  {
    modalType: "attributes",
    name: "attributes",
    content: [
      {
        elementName: "Global Attributes",
        elementTags: "All HTML Elements",
        attributes: [
          "class",
          "id",
          "style",
          "title",
          "role",
          "aria-label",
          "aria-labelledby",
          "aria-hidden",
          "aria-expanded",
          "aria-checked",
          "aria-required",
          "aria-disabled",
          "aria-controls",
          "aria-describedby",
          "aria-pressed",
          "aria-live",
          "aria-busy",
          "aria-atomic",
          "aria-relevant",
          "aria-haspopup",
          "aria-invalid",
          "autocapitalize",
          "contenteditable",
          "draggable",
          "lang",
          "dir",
          "tabindex",
          "accesskey",
          "spellcheck",
          "translate",
          "slot",
          "dataset",
        ],
        description:
          "Attributes that are globally applicable to all HTML elements.",
      },
      {
        elementName: "Anchor Attributes",
        elementTags: "&lt;a&gt;, &lt;area&gt;, &lt;link&gt;",
        attributes: [
          "href",
          "target",
          "rel",
          "download",
          "hreflang",
          "ping",
          "referrerpolicy",
        ],
        description:
          "Attributes used for creating links and defining relationships between documents or resources.",
      },
      {
        elementName: "Media Attributes",
        elementTags:
          "&lt;img&gt;, &lt;video&gt;, &lt;audio&gt;, &lt;source&gt;, &lt;track&gt;",
        attributes: [
          "src",
          "alt",
          "srcset",
          "sizes",
          "crossorigin",
          "decoding",
          "loading",
          "poster",
          "preload",
          "autoplay",
          "muted",
          "loop",
          "controls",
          "width",
          "height",
          "lazyload",
        ],
        description:
          "Attributes used for embedding and controlling media content.",
      },
      {
        elementName: "Form Attributes",
        elementTags:
          "&lt;form&gt;, &lt;input&gt;, &lt;textarea&gt;, &lt;button&gt;, &lt;select&gt;, &lt;label&gt;, &lt;fieldset&gt;, &lt;legend&gt;, &lt;datalist&gt;, &lt;optgroup&gt;, &lt;option&gt;",
        attributes: [
          "form",
          "action",
          "method",
          "enctype",
          "novalidate",
          "autocomplete",
          "accept",
          "accept-charset",
          "for",
          "name",
          "type",
          "value",
          "placeholder",
          "required",
          "readonly",
          "disabled",
          "maxlength",
          "minlength",
          "pattern",
          "checked",
          "selected",
          "multiple",
          "list",
          "size",
          "step",
        ],
        description:
          "Attributes used for collecting and managing user input through forms.",
      },
      {
        elementName: "Input and Form Field Attributes",
        elementTags:
          "&lt;input&gt;, &lt;textarea&gt;, &lt;select&gt;, &lt;option&gt;, &lt;button&gt;",
        attributes: [
          "type",
          "name",
          "value",
          "placeholder",
          "readonly",
          "disabled",
          "required",
          "maxlength",
          "minlength",
          "pattern",
          "checked",
          "multiple",
          "list",
          "size",
          "autocomplete",
          "autofocus",
          "formaction",
          "formenctype",
          "formmethod",
          "formtarget",
          "formnovalidate",
          "dirname",
          "step",
          "min",
          "max",
          "height",
          "width",
          "src",
        ],
        description:
          "Attributes specific to input elements and other form-related fields.",
      },
      {
        elementName: "Table Attributes",
        elementTags:
          "&lt;table&gt;, &lt;th&gt;, &lt;td&gt;, &lt;tr&gt;, &lt;thead&gt;, &lt;tbody&gt;, &lt;tfoot&gt;, &lt;caption&gt;, &lt;colgroup&gt;, &lt;col&gt;",
        attributes: ["headers", "scope", "rowspan", "colspan", "span"],
        description:
          "Attributes used for structuring and organizing data in tabular form.",
      },
      {
        elementName: "Document Metadata Attributes",
        elementTags:
          "&lt;meta&gt;, &lt;head&gt;, &lt;base&gt;, &lt;title&gt;, &lt;style&gt;, &lt;link&gt;",
        attributes: ["charset", "http-equiv", "content", "name", "media"],
        description:
          "Attributes used for defining metadata and setting global information for the document.",
      },

      {
        elementName: "Interactive Attributes",
        elementTags:
          "&lt;details&gt;, &lt;summary&gt;, &lt;menu&gt;, &lt;dialog&gt;",
        attributes: ["open"],
        description:
          "Attributes used for interactive elements that the user can show or hide.",
      },
      {
        elementName: "ARIA and Accessibility Attributes",
        elementTags: "Any HTML Element",
        attributes: ["role", "aria-*"],
        description:
          "Attributes used for improving accessibility by providing additional information for assistive technologies.",
      },
    ],
  },
];
